import { ReactNode, RefObject, useRef } from 'react';
import { DataAvailabilityInlineButton } from '../components/DataAvailabilityButton';
import { useDataAvailabilityEntry } from './useDataAvailabilityEntry';
import { DATA_AVAILABILITY_COPY } from '../constants/reconciliationsCopy';
import type { TabBarAction } from '../../../../../common/TabBarActions/TabBarActions';
import { useIsMobile } from '../../../../../common/_custom/Hooks/useIsMobile';
import { useFeatureVisibility, useVisibilityConfig } from '../../../../../utils/useVisibilityConfig';
import { VISIBILITY_KEYS } from '../../../../../utils/constants/visibilityKeys';

const DRAWER_VISIBILITY_KEYS = { reconDrawerVisibility: VISIBILITY_KEYS.RECONCILIATIONS.DRAWER_ENABLE };

/** The Data Availability action for a module tab bar, plus the modal the host must render once. */
export function useTabBarDataAvailabilityAction(
    orgId: string | undefined,
    isPDFReport: boolean,
    menuTriggerRef: RefObject<HTMLButtonElement>,
): { action: TabBarAction | null; modal: ReactNode } {
    const isMobile = useIsMobile();
    const { isConfigLoaded } = useVisibilityConfig();
    const { reconDrawerVisibility } = useFeatureVisibility(DRAWER_VISIBILITY_KEYS);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const { isOpen, open, modal } = useDataAvailabilityEntry(orgId ?? '', menuTriggerRef);

    const isAvailable = !isMobile && !isPDFReport && isConfigLoaded && reconDrawerVisibility.show && !!orgId;
    if (!isAvailable) return { action: null, modal: null };

    return {
        action: {
            id: 'dataAvailability',
            inline: <DataAvailabilityInlineButton buttonRef={buttonRef} expanded={isOpen} onClick={() => open(buttonRef)} />,
            menuItem: { name: DATA_AVAILABILITY_COPY.BUTTON, onClick: () => open(menuTriggerRef) },
        },
        modal,
    };
}
